import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class BrandInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let { headers, params } = request;
    headers = headers.set('Brand-Id', `${environment.brandId}`);
    params = params.set('brandId', environment.brandId);

    return next.handle(
      request.clone({
        headers,
        params,
      })
    );
  }
}
